import admin from './admin/admin.js'
import user from './users/user.js'
import users from './users/users.js'

import permission from './permissions/permission.js'
import permissions from './permissions/permissions.js'

import announcement from './announcements/announcement.js'
import announcements from './announcements/announcements.js'

import ticketingTicket from './tickets/ticketingTicket.js'
import ticketingTickets from './tickets/ticketingTickets.js'
import ticketingCompany from './tickets/ticketingCompany.js'
import ticketingCompanies from './tickets/ticketingCompanies.js'
import ticketingContact from './tickets/ticketingContact.js'
import ticketingContacts from './tickets/ticketingContacts.js'
import ticketingCategory from './tickets/ticketingCategory.js'
import ticketingCategories from './tickets/ticketingCategories.js'

import unit from './units/unit.js'
import units from './units/units.js'

import sample from './samples/sample'
import samples from './samples/samples'
import sampleRequest from './samples/sampleRequest'
import sampleRequests from './samples/sampleRequests'

import account from './accounts/account'
import accounts from './accounts/accounts'
import contact from './contacts/contact'
import contacts from './contacts/contacts'

import document from './documents/document.js'
import documents from './documents/documents.js'
import documentType from './documents/documentType.js'
import documentTypes from './documents/documentTypes.js'

import rfq from './rfqs/rfq.js'
import rfqs from './rfqs/rfqs.js'
import rfqStatusSummary from './rfqs/rfqStatusSummary'
import drawingHighlightStatusSummary from './drawingHighlights/drawingHighlightStatusSummary'
import estimationStatusSummary from './estimations/estimationStatusSummary'
import estimation from './estimations/estimation.js'
import estimations from './estimations/estimations.js'
import estimationDetail from './estimations/estimationDetail'
import estimationDetails from './estimations/estimationDetails'
import estimationSummary from './estimations/estimationSummary'
import estimationParameters from './estimations/estimationParameters'
import material from './materials/material.js'
import materials from './materials/materials.js'
import installMethod from './installationMethods/installMethod'
import installMethods from './installationMethods/installMethods'
import drawingHighlight from './drawingHighlights/drawingHighlight'
import drawingHighlights from './drawingHighlights/drawingHighlights'
import drawingHighlightImage from './drawingHighlights/drawingHighlightImage'

import cladifyRfq from './rfqs/cladifyRfq.js'
import cladifyRfqs from './rfqs/cladifyRfqs.js'
import mitrexRfq from './rfqs/mitrexRfq.js'

import rfqDocument from './rfqs/rfqDocument'
import rfqDocuments from './rfqs/rfqDocuments'
import rfqDocumentType from './rfqDocumentTypes/rfqDocumentType.js'
import rfqDocumentTypes from './rfqDocumentTypes/rfqDocumentTypes.js'

import service from './services/service'
import services from './services/services'
import serviceType from './services/serviceTypes'
import serviceTypes from './services/serviceTypes'
import elevation from './elevations/elevation'
import elevations from './elevations/elevations'
import installation from './installations/installation'
import installations from './installations/installations'
import installationType from './installations/installationType'
import installationTypes from './installations/installationTypes'
import fabrication from './fabrications/fabrication'
import fabrications from './fabrications/fabrications'
import fabricationType from './fabrications/fabricationType'
import fabricationTypes from './fabrications/fabricationTypes'
import processingMethod from './processingMethods/processingMethod'
import processingMethods from './processingMethods/processingMethods'
import processingMethodType from './processingMethods/processingMethodType'
import processingMethodTypes from './processingMethods/processingMethodTypes'

import cladifyEstimation from './estimations/cladifyEstimation'
import cladifyEstimations from './estimations/cladifyEstimations'
import mitrexEstimation from './estimations/mitrexEstimation'

import estimationInsulation from './estimations/estimationInsulation'
import estimationInsulations from './estimations/estimationInsulations'

import estimationItem from './estimationItems/estimationItem'
import estimationItems from './estimationItems/estimationItems'
import estimationItemMitrex from './estimationItems/estimationItemMitrex'
import estimationItemsMitrex from './estimationItems/estimationItemsMitrex'

import estimationItemElevation from './estimationItemElevations/estimationItemElevation'
import estimationItemElevations from './estimationItemElevations/estimationItemElevations'
import estimationItemElevationMitrex from './estimationItemElevations/estimationItemElevationMitrex'
import estimationItemElevationsMitrex from './estimationItemElevations/estimationItemElevationsMitrex'

import estimationItemMaterial from './estimationItemMaterials/estimationItemMaterial'
import estimationItemMaterials from './estimationItemMaterials/estimationItemMaterials'
import estimationItemMaterialMitrex from './estimationItemMaterials/estimationItemMaterialMitrex'
import estimationItemMaterialsMitrex from './estimationItemMaterials/estimationItemMaterialsMitrex'

import estimationItemProcessing from './estimationItemProcessings/estimationItemProcessing'
import estimationItemProcessings from './estimationItemProcessings/estimationItemProcessings'
import estimationItemProcessingMitrex from './estimationItemProcessings/estimationItemProcessingMitrex'
import estimationItemProcessingsMitrex from './estimationItemProcessings/estimationItemProcessingsMitrex'

import estimationItemFabrication from './estimationItemFabrications/estimationItemFabrication'
import estimationItemFabrications from './estimationItemFabrications/estimationItemFabrications'
import estimationItemFabricationMitrex from './estimationItemFabrications/estimationItemFabricationMitrex'
import estimationItemFabricationsMitrex from './estimationItemFabrications/estimationItemFabricationsMitrex'

import estimationItemInstallation from './estimationItemInstallations/estimationItemInstallation'
import estimationItemInstallations from './estimationItemInstallations/estimationItemInstallations'
import estimationItemInstallationMitrex from './estimationItemInstallations/estimationItemInstallationMitrex'
import estimationItemInstallationsMitrex from './estimationItemInstallations/estimationItemInstallationsMitrex'

import estimationService from './estimationServices/estimationService'
import estimationServices from './estimationServices/estimationServices'
import estimationServiceMitrex from './estimationServices/estimationServiceMitrex'
import estimationServicesMitrex from './estimationServices/estimationServicesMitrex'

import estimationSummaryMitrex from './estimations/estimationSummaryMitrex'

import project from './projects/project.js'
import projectSync from './projects/projectSync.js'
import projects from './projects/projects.js'
import proposal from './proposals/proposal.js'
import proposals from './proposals/proposals.js'
import images from './proposals/images.js'

import cutsheet from './cutsheets/cutsheet.js'
import cutsheets from './cutsheets/cutsheets.js'
import cutsheetPart from './cutsheets/cutsheetPart.js'
import cutsheetParts from './cutsheets/cutsheetParts.js'
import cutsheetSteps from './cutsheets/cutsheetSteps.js'
import cutsheetPartSteps from './cutsheets/cutsheetPartSteps.js'
import cutsheetSkids from './cutsheets/cutsheetSkids.js'
import cutsheetAssembly from './assemblies/cutsheetAssembly.js'
import cutsheetAssemblyDetails from './assemblies/cutsheetAssemblyDetails.js'

import bom from './boms/bom.js'
import boms from './boms/boms.js'
import bomDetail from './boms/bomDetail.js'
import bomDetails from './boms/bomDetails.js'
import order from './orders/order.js'
import orders from './orders/orders.js'
import orderDetail from './orders/orderDetail.js'
import orderDetails from './orders/orderDetails.js'
import orderDetailsBom from './orders/orderDetailsBom.js'
import orderDetailsBoms from './orders/orderDetailsBoms.js'
import orderDetailsStorage from './orders/orderDetailsStorage.js'
import orderDetailsStorages from './orders/orderDetailsStorages.js'
import product from './products/product.js'
import products from './products/products.js'
import productCategory from './products/productCategory.js'
import productCategories from './products/productCategories.js'
import productSubcategory from './products/productSubcategory.js'
import productSubcategories from './products/productSubcategories.js'
import productType from './products/productType.js'
import productTypes from './products/productTypes.js'
import supplier from './suppliers/supplier.js'
import suppliers from './suppliers/suppliers.js'
import inventories from './inventories/inventories.js'
import productionSheet from './productionSheets/productionSheet.js'
import productionSheets from './productionSheets/productionSheets.js'
import productionSheetsItem from './productionSheets/productionSheetsItem'
import productionSheetsItems from './productionSheets/productionSheetsItems'
import finishingStep from './finishingSteps/finishingStep'
import finishingSteps from './finishingSteps/finishingSteps'

import workstation from './workstations/workstation'
import workstations from './workstations/workstations'
import workstationQueue from './workstations/workstationQueue'
import workstationQueues from './workstations/workstationQueues'
import workstationWorkStep from './workstations/workstationWorkStep'
import workstationWorkSteps from './workstations/workstationWorkSteps'
import workStep from './workSteps/workStep'
import workSteps from './workSteps/workSteps'
import masterProduction from './masterProductions/masterProduction'
import masterProductions from './masterProductions/masterProductions'
import masterProductionStep from './masterProductions/masterProductionStep'
import masterProductionSteps from './masterProductions/masterProductionSteps'
import warehouse from './warehouses/warehouse'
import warehouses from './warehouses/warehouses'
import warehouseLocation from './warehouses/warehouseLocation'
import warehouseLocations from './warehouses/warehouseLocations'
import storage from './storages/storage'
import storages from './storages/storages'
import storageType from './storages/storageType'
import storageTypes from './storages/storageTypes'
import storageUnit from './storages/storageUnit'
import storageUnits from './storages/storageUnits'
import delivery from './deliveries/delivery'
import deliveries from './deliveries/deliveries'
import deliveryStorage from './deliveries/deliveryStorage'
import deliveryStorages from './deliveries/deliveryStorages'

import estimationPreview from './customerPortal/estimationPreview'

import installationSummary from './installationSummary/installationSummary'
import installationItem from './installationItems/installationItem'
import installationItems from './installationItems/installationItems'
import skid from './skids/skid'
import skids from './skids/skids'

export default {
  //admin
  admin,
  //user
  user,
  users,
  //permissions - policies
  permission,
  permissions,
  //announcements
  announcements,
  announcement,
  //document
  document,
  documents,
  documentType,
  documentTypes,
  //ticketing
  ticketingTicket,
  ticketingTickets,
  ticketingCompany,
  ticketingCompanies,
  ticketingContact,
  ticketingContacts,
  ticketingCategory,
  ticketingCategories,
  //units
  unit,
  units,
  //sample requests
  sample,
  samples,
  sampleRequest,
  sampleRequests,
  //crm
  account,
  accounts,
  contact,
  contacts,
  //estimations
  rfq,
  rfqs,
  estimation,
  estimations,
  estimationDetail,
  estimationDetails,
  estimationSummary,
  estimationParameters,
  material,
  materials,
  installMethod,
  installMethods,
  drawingHighlight,
  drawingHighlights,
  drawingHighlightImage,
  //cladify estimations
  rfqStatusSummary,
  drawingHighlightStatusSummary,
  estimationStatusSummary,
  cladifyRfq,
  mitrexRfq,
  cladifyRfqs,
  rfqDocument,
  rfqDocuments,
  rfqDocumentType,
  rfqDocumentTypes,
  service,
  services,
  serviceType,
  serviceTypes,
  elevation,
  elevations,
  installation,
  installations,
  installationType,
  installationTypes,
  fabrication,
  fabrications,
  fabricationType,
  fabricationTypes,
  processingMethod,
  processingMethods,
  processingMethodType,
  processingMethodTypes,
  estimationItem,
  estimationItems,
  estimationItemMitrex,
  estimationItemsMitrex,
  estimationItemElevation,
  estimationItemElevationMitrex,
  estimationItemElevations,
  estimationItemElevationsMitrex,
  estimationItemMaterial,
  estimationItemMaterialMitrex,
  estimationItemMaterials,
  estimationItemMaterialsMitrex,
  estimationItemProcessing,
  estimationItemProcessingMitrex,
  estimationItemProcessings,
  estimationItemProcessingsMitrex,
  estimationItemFabrication,
  estimationItemFabricationMitrex,
  estimationItemFabrications,
  estimationItemFabricationsMitrex,
  estimationItemInstallation,
  estimationItemInstallationMitrex,
  estimationItemInstallations,
  estimationItemInstallationsMitrex,
  estimationService,
  estimationServiceMitrex,
  estimationServices,
  estimationServicesMitrex,
  estimationSummaryMitrex,
  cladifyEstimation,
  cladifyEstimations,
  mitrexEstimation,
  estimationInsulation,
  estimationInsulations,
  //proposals
  project,
  projects,
  projectSync,
  proposal,
  proposals,
  images,
  //manufacturing - phase A
  cutsheet,
  cutsheets,
  cutsheetPart,
  cutsheetParts,
  cutsheetSteps,
  cutsheetPartSteps,
  cutsheetSkids,
  cutsheetAssembly,
  cutsheetAssemblyDetails,
  //inventory - phase B
  bom,
  boms,
  bomDetail,
  bomDetails,
  order,
  orders,
  orderDetail,
  orderDetails,
  orderDetailsBom,
  orderDetailsBoms,
  orderDetailsStorage,
  orderDetailsStorages,
  product,
  products,
  productCategory,
  productCategories,
  productSubcategory,
  productSubcategories,
  productType,
  productTypes,
  supplier,
  suppliers,
  inventories,
  productionSheet,
  productionSheets,
  productionSheetsItem,
  productionSheetsItems,
  finishingStep,
  finishingSteps,
  //warehousing - phase C
  masterProduction,
  masterProductions,
  masterProductionStep,
  masterProductionSteps,
  workstation,
  workstations,
  workstationQueue,
  workstationQueues,
  workStep,
  workSteps,
  workstationWorkStep,
  workstationWorkSteps,
  warehouse,
  warehouses,
  warehouseLocation,
  warehouseLocations,
  storage,
  storages,
  storageType,
  storageTypes,
  delivery,
  deliveries,
  deliveryStorage,
  deliveryStorages,
  storageUnit,
  storageUnits,
  estimationPreview,
  installationSummary,
  installationItem,
  installationItems,
  skid,
  skids
}
